export default __webpack_public_path__ + "static/buchla-700-main-screen-cf0ea0e8202eac2cf456b100658d2c30.jpg";